import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type EuerVatTaxAccountCheckQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  year: Types.Scalars["Int"];
}>;

export type EuerVatTaxAccountCheckQuery = {
  __typename?: "Query";
  euerVatTaxAccountCheck: {
    __typename?: "EuerVatTaxAccountCheck";
    taxNumber: string;
    queryDate?: string | null;
    direction: Types.EuerVatTaxAccountDirection;
    paid: {
      __typename?: "EuerVatTaxAccountLine";
      total: number;
      entries: Array<{
        __typename?: "EuerVatTaxAccountEntry";
        period: string;
        date: string;
        amount: number;
        explanation: string;
      }>;
    };
    refunded: {
      __typename?: "EuerVatTaxAccountLine";
      total: number;
      entries: Array<{
        __typename?: "EuerVatTaxAccountEntry";
        period: string;
        date: string;
        amount: number;
        explanation: string;
      }>;
    };
    unclear: {
      __typename?: "EuerVatTaxAccountLine";
      total: number;
      entries: Array<{
        __typename?: "EuerVatTaxAccountEntry";
        period: string;
        date: string;
        amount: number;
        explanation: string;
      }>;
    };
  };
};

export const EuerVatTaxAccountCheckDocument = gql`
  query euerVatTaxAccountCheck($email: String!, $year: Int!) {
    euerVatTaxAccountCheck(email: $email, year: $year) {
      taxNumber
      queryDate
      direction
      paid {
        total
        entries {
          period
          date
          amount
          explanation
        }
      }
      refunded {
        total
        entries {
          period
          date
          amount
          explanation
        }
      }
      unclear {
        total
        entries {
          period
          date
          amount
          explanation
        }
      }
    }
  }
`;

/**
 * __useEuerVatTaxAccountCheckQuery__
 *
 * To run a query within a React component, call `useEuerVatTaxAccountCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useEuerVatTaxAccountCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEuerVatTaxAccountCheckQuery({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useEuerVatTaxAccountCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    EuerVatTaxAccountCheckQuery,
    EuerVatTaxAccountCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EuerVatTaxAccountCheckQuery,
    EuerVatTaxAccountCheckQueryVariables
  >(EuerVatTaxAccountCheckDocument, options);
}
export function useEuerVatTaxAccountCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EuerVatTaxAccountCheckQuery,
    EuerVatTaxAccountCheckQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EuerVatTaxAccountCheckQuery,
    EuerVatTaxAccountCheckQueryVariables
  >(EuerVatTaxAccountCheckDocument, options);
}
export type EuerVatTaxAccountCheckQueryHookResult = ReturnType<
  typeof useEuerVatTaxAccountCheckQuery
>;
export type EuerVatTaxAccountCheckLazyQueryHookResult = ReturnType<
  typeof useEuerVatTaxAccountCheckLazyQuery
>;
export type EuerVatTaxAccountCheckQueryResult = Apollo.QueryResult<
  EuerVatTaxAccountCheckQuery,
  EuerVatTaxAccountCheckQueryVariables
>;
